import { GET_DETAIL_EXPERIENCE_ITEMS } from 'constants/detail-experience';

const initialState = {
  isFetching: false,
  data: {},
  error: null,
};

export const detailExperienceReducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case `${GET_DETAIL_EXPERIENCE_ITEMS}_PENDING`: {
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    }
    case `${GET_DETAIL_EXPERIENCE_ITEMS}_FULFILLED`: {
      return {
        ...state,
        isFetching: false,
        data: payload,
        error: null,
      };
    }
    case `${GET_DETAIL_EXPERIENCE_ITEMS}_REJECTED`: {
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };
    }
    default:
      return state;
  }
};
